import React, { PropsWithChildren } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export function RecaptchaWrapper({ children }: PropsWithChildren) {
    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LfqTn0rAAAAAGwdZJCgo7x6d7dhwEWovkGNfi_r">
            {children}
        </GoogleReCaptchaProvider>
    );
}
